
export const LEFT_OF_RANGE = {
  id: '3-nook',
  name: 'Kitchen Nook',
  levels: [
    {
      tileSize: 256,
      size: 256,
      fallbackOnly: true,
    },
    {
      tileSize: 512,
      size: 512,
    },
    {
      tileSize: 512,
      size: 1024,
    },
    {
      tileSize: 512,
      size: 2048,
    },
  ],
  faceSize: 2048,
  initialViewParameters: {
    yaw: 1.1129830383871777,
    pitch: 0.5918074059836975,
    fov: 1.4236357722889479
  },
  linkHotspots: [
    {
      yaw: -3.1348194389901067,
      pitch: 0.05747140310121779,
      rotation: 3.141592653589793,
      target: '0-init',
    },
    {
      yaw: -1.9255138742709352,
      pitch: 0.1805015636453966,
      rotation: 6.283185307179586,
      target: '5-dining',
    },
    {
      yaw: -2.2557113599839003,
      pitch: 0.1675670396831812,
      rotation: 3.9269908169872414,
      target: '2-island',
    },
    {
      yaw: 3.028236801118336,
      pitch: 0.38058937073149757,
      rotation: 4.71238898038469,
      target: '1-range',
    },
    {
      yaw: -1.5492979215185123,
      pitch: 0.19946185043485443,
      rotation: 2.356194490192345,
      target: '4-prep',
    },
  ],
  infoHotspots: [
//     {
//       yaw: 1.4233281530580317,
//       pitch: 0.33310766329745256,
//       title: `Silicone Tools`,
//       subhead: `Silicone Tools`,
//       text: /*html*/`
//         <ul>
//            <li><b>3-year guarantee</b></li>
//             <li>
//                 <b>Dishwasher-safe | Heat-safe to 450°F (230°C)</b>
//             </li>
//             <li><b>Safe for all cookware.</b></li>
//             <li>
//                 Each tool features thin beveled edges, an ergonomic soft-touch
//                 handle, and a slip-resistant silicone design that keeps food
//                 from sliding. Nonstick-safe.
//            </li>
//             <li>
//                 <b>Tools with a sturdy stainless core</b> are flexible enough to give
//                 it just the right bend to glide under food easily.
//             </li>
//             <li>
//                 <b>Tools with a durable nylon core</b> give you sturdy, reliable
//                 support for making any recipe.
//             </li>
//             <li>
//                 <b>Silicone Utensil Set</b> includes: Silicone Slotted Turner, Silicone
//                 Angled Turner, and Silicone Slotted Spoon.
//             </li>
//             <br/>
//             <!---->
//                 <br/>
//             <span class="title">Silicone Turner</span>
//             <li><b>#100689</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>11" (28 cm) long</li>
//             <li>Silicone head with stainless steel core.</li>
//             <li>
//                 <b>Great to</b> mix, fold, scrape and combine ingredients for any recipe.
//             </li>
//             <!---->

//                 <br/>
//             <span class="title">Silicone Slotted Turner</span>
//             <li><b>#100679</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>11¾" (29.5 cm) long</li>
//             <li>Silicone head with stainless steel core.</li>
//             <li>
//                 <b>Great to</b> flip, stir, lift, and transfer foods with grease or
//                 liquid like burgers.
//             </li>
//             <!---->
//                 <br/>
//             <span class="title">Silicone Angled Turner</span>
//             <li><b>#100680</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>11¾" (29.5 cm) long</li>
//             <li>Silicone head with stainless steel core.</li>
//             <li>
//                 <b>Great to</b> flip, mix, lift and transfer foods with that are soft
//                 or delicate like pancakes.
//             </li>

//                 <br/>
//             <span class="title">Silicone Straining Ladle</span>
//             <li><b>#100682</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>
//                 11¾" (29.5 cm) long | 6-oz. (175 g) capacity with a 4-oz. (125
//                 g) serving marking.
//             </li>
//             <li>Silicone head with nylon core.</li>
//             <li>
//                 <b>Great for</b> scooping, straining, and pouring soups, stocks,
//                 vegetables, and more.
//             </li>
//             <!---->
//                 <br/>
//             <span class="title">Silicone Pasta Fork</span>
//             <li><b>#100683</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>11½" (29 cm) long</li>
//             <li>Silicone head with nylon core.</li>
//             <li>
//                 <b>Great for</b> scooping and serving pasta or mixing it with sauce,
//                 veggies, or meat. The tines easily hold on to noodles without
//                 tearing or breaking them.
//             </li>
//             <!---->
//                 <br/>
//             <span class="title">Silicone Spoon</span>
//             <li><b>#100684</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>11½" (29 cm) long</li>
//             <li>Silicone head with nylon core.</li>
//             <li><b>Great for</b> stirring and serving whatever you're dishing out.</li>
//             <!---->
//                 <br/>
//             <span class="title">Silicone Slotted Spoon</span>
//             <li><b>#100685</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>11½" (29 cm) long</li>
//             <li>Silicone head with nylon core.</li>
//             <li><b>Great for</b> stirring and serving whatever you're dishing out.</li>
//             <!---->
//                 <br/>
//             <span class="title">Silicone Fish Spatula</span>
//             <li><b>#100686</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>12½" (31 cm) long</li>
//             <li>Silicone head with stainless steel core.</li>
//             <li>
//                 <b>Great for</b> sliding under fish fillets, while its long slots let
//                 liquids and oil drain back into the pan. It's also great for
//                 flipping and serving delicate foods like crab cakes or pancakes
//                 or transferring baked goods from a pan to a cooling rack.
//             </li>
//             <!---->
//                 <br/>
//             <span class="title">Silicone Scoop &amp; Serve Spatula</span>
//             <li><b>#100687</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>11¾" (29.5 cm) long</li>
//             <li>Silicone head with nylon core.</li>
//             <li>
//                 <b>Great for</b> scooping casseroles, lasagna, pasta bakes, au gratin
//                 potatoes, and cobblers. The scoop has high sides that keep your
//                 lasagna stack intact and catch veggies, sauce, and fruit in
//                 whatever you’re dishing out.
//             </li>
//             <!---->
//                 <br/>
//             <span class="title">Small Silicone Spatula</span>
//             <li><b>#100688</b></li>
//             <li><b>USD</b> $16 | <b>CAD</b> $20</li>
//             <li>11" (28-cm) long</li>
//             <li>Silicone head with nylon core.</li>
//             <li>
//                 <b>Great to</b> flip, mix, lift and transfer smaller foods that are
//                 soft or delicate, like eggs and cookies.
//             </li>
//         </ul>
// `,
//       images: [
//         `<img width="640" alt="silicone-tools-01.jpeg" src="https://pamperedchef.widen.net/content/gkpfa7u4fk/jpeg/silicone-tools-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
//         `<img width="640" alt="silicone-tools-02.jpeg" src="https://pamperedchef.widen.net/content/g0atgpjcg1/jpeg/silicone-tools-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
//         `<img width="640" alt="silicone-tools-03.jpeg" src="https://pamperedchef.widen.net/content/ja4xwjaen2/jpeg/silicone-tools-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
//         `<img width="640" alt="silicone-tools-04.jpeg" src="https://pamperedchef.widen.net/content/gzv2lywhdr/jpeg/silicone-tools-04.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`
//       ],
//       videos: [
//         `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/xhtij4jfli/video-product-ss22-silicone-utensil-set-loop-virtual-kitchen-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
//         `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/ro6yzileng/video-product-ss22-silicone-scoop-and-serve-spatula-loop-virtual-kitchen-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
//         `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/b0jkqkuzuu/video-product-ss22-silicone-straining-ladle-loop-virtual-kitchen-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`
//       ]
//     },
    {
      yaw: 1.4233281530580317,
      pitch: 0.33310766329745256,
      title: `Egg Separator`,
      subhead: `Stainless Steel Egg Separator`,
      text: `
          <ul>
            <li><b>#100678</b></li>
            <li>
              <b>USD</b>
              $20 |
              <b>CAD</b>
              $25
            </li>
            <li>3-year guarantee</li>
            <li>Dishwasher-safe</li>
            <li>11½" (29 cm) long with handle opened.</li>
            <li>Use with all sizes of eggs.</li>
            <li>
              Silicone tip and handle ensure it will stay in place while in use.
            </li>
            <li>
              Folding handle for easy storage and fits a wide range of mixing and prep
              bowls.
            </li>
            <li>
              <b>Great for</b>
              quickly and easily separating yolks from egg whites.
            </li>
          </ul>`,
      images: [
        `<img width="640" alt="egg-separator-01.jpeg" src="https://pamperedchef.widen.net/content/h2r3abgx4o/jpeg/egg-separator-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
        `<img width="640" alt="egg-separator-02.jpeg" src="https://pamperedchef.widen.net/content/8wgqh41nmo/jpeg/egg-separator-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
        `<img width="640" alt="egg-separator-03.jpeg" src="https://pamperedchef.widen.net/content/tyqhnxf7td/jpeg/egg-separator-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`
      ],
      videos: [
        `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/4p6wuls2fv/video-product-ss22-stainless-steel-egg-separator-loop-virtual-kitchen-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`
      ]
    },
    {
      yaw: 1.9057458383091488,
      pitch: 0.3423765268552117,
      title: `Spider Strainer`,
      subhead: `Spider Strainer`,
      text: `
    <ul>
      <li><b>#100694</b></li>
      <li>
        <b>USD</b>
        $20 |
        <b>CAD</b>
        $25
      </li>
      <li>3-year guarantee</li>
      <li>Dishwasher-safe</li>
      <li>13½ (34 cm) long</li>
      <li>Sturdy stainless steel and silicone</li>
      <li>
        The large, durable stainless-steel wire basket, helps you easily scoop
        large amounts of food and strain liquids quickly.
      </li>
      <li>
        Lift food out of boiling water, soups, stocks, or oil using the long
        soft-grip handle so your hands can stay comfortable and safe.
      </li>
      <li>
        <b>Great for:</b>
        ravioli, eggs, deep frying, blanching, and other delicate foods.
      </li>
    </ul>
  `,
      images: [
        `<img width="640" alt="spider-strainer-01.jpeg" src="https://pamperedchef.widen.net/content/qrg3jj1wad/jpeg/spider-strainer-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
        `<img width="640" alt="spider-strainer-02.jpeg" src="https://pamperedchef.widen.net/content/pvfxlrbciz/jpeg/spider-strainer-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`
      ],
      videos: [
        `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/plfa2xtyvq/video-product-ss22-spider-strainer-loop-virtual-kitchen-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`
      ]
    },
    {
      pitch: 0.4332949444632703,
      yaw: 0.35108189483235286,
      title: `Meal Mixes`,
      subhead: `Meal Mixes`,
      text: `
    <ul>
      <span class="title">Pad Thai Mix</span>
      <li><b>#100526</b></li>
      <li>
        <b>USD</b>
        $11 |
        <b>CAD</b>
        $15
      </li>
      <li>Gluten-Free, Kosher | Contains sesame.</li>
      <li>Three 2.5-oz. (70-g) packets</li>
      <li>
        Skip delivery—make your own pad thai at home in less time than it takes
        to get takeout! Just add soy sauce, your favorite protein, and fresh
        toppings to create flavorful meals.
      </li>
      <li>
        <b>Great for:</b>
        Pad Thai, vegetable stir fry, and rice with shrimp.
      </li>
      <span class="title">Scampi Mix</span>
      <li><b>#100715</b></li>
      <li>
        <b>USD</b>
        $11 |
        <b>CAD</b>
        $15
      </li>
      <li>Gluten-Free, Kosher | Contains milk.</li>
      <li>Three 0.7-oz. (19-g) packets</li>
      <li>
        Make garlicky, buttery, delicious shrimp or chicken scampi in your own
        kitchen! Just add butter, your favorite protein, and noodles for a meal
        just like you'd get in a restaurant.
      </li>
      <li>
        <b>Great for:</b> chicken scampi, shrimp fettucine, and baked chicken.
      </li>
      <li>
        Both mixes are also in the
        <b>Meal Mix Set:</b>
        Pad Thai Mix, Scampi Mix, and Pasta Tongs.
      </li>
    </ul>
  `,
      images: [
        `<img width="640" alt="meal-mix-01.jpeg" src="https://pamperedchef.widen.net/content/vowa6sxcdj/jpeg/meal-mix-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
        `<img width="640" alt="meal-mix-02.jpeg" src="https://pamperedchef.widen.net/content/zgohwjtyrn/jpeg/meal-mix-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
        `<img width="640" alt="meal-mix-03.jpeg" src="https://pamperedchef.widen.net/content/qpyfejds1y/jpeg/meal-mix-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
        `<img width="640" alt="meal-mix-04.jpeg" src="https://pamperedchef.widen.net/content/zf09kamgt8/jpeg/meal-mix-04.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
      ],
      videos: [
        `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/m708w6qaso/video-product-ways-to-use-pad-thai-meal-mix-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>`,
        `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/alxrrl1kli/video-product-ways-to-use-scampi-meal-mix-usca.mp4" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>`
      ]
    },
  ],
} ;